import React, { Component } from 'react';
import styled from 'styled-components';

import DesktopApp from './Desktop';
import BaseLoader from './shared/Loader';
import PreviewApp from './Preview';

const Main = styled.main`
    max-width: 1165px;
    margin: 24px auto 0;
    padding-left: 12px;
    padding-right: 12px;
    display: flex;
    overflow: hidden;
`;

const Loader = styled(BaseLoader)`
    margin: 0 auto;
`;

const RESIZE_THRESHOLD = 768;

class App extends Component {
    state = {
        isLoading: true,
        hasLoadingError: false,
        isMobile: false,
        config: null,
    };

    componentDidMount() {
        this.loadConfig();

        this.handleResize();
        window.addEventListener('resize', this.handleResize);
    }

    loadConfig() {
        this.setState({
            isLoading: true,
            hasLoadingError: false,
        });

        fetch(this.props.pathToConfig)
            .then(resp => {
                if (resp.ok) {
                    try {
                        return resp.json();
                    } catch (e) {
                        throw new Error(e);
                    }
                } else {
                    throw new Error();
                }
            })
            .then(config =>
                this.setState({
                    config,
                    isLoading: false,
                    hasLoadingError: false,
                })
            )
            .catch(e => {
                console.error(`Error in loadConfig(): ${e}`);
                this.setState({
                    isLoading: false,
                    hasLoadingError: true,
                });
            });
    }

    render() {
        const { previewForKey } = this.props;
        const { isLoading, hasLoadingError, config } = this.state;

        if (previewForKey) {
            return (
                <div>
                    {this.renderLoading()}
                    {!isLoading &&
                        !hasLoadingError && (
                            <PreviewApp
                                config={config}
                                previewKey={previewForKey}
                            />
                        )}
                </div>
            );
        }

        return (
            <Main>
                {this.renderLoading()}
                {this.renderMain()}
            </Main>
        );
    }

    renderLoading() {
        const { isLoading } = this.state;

        if (!isLoading) return null;

        return <Loader />;
    }

    renderMain() {
        const { isLoading, hasLoadingError, isMobile, config } = this.state;

        if (isLoading || hasLoadingError) return null;

        return (
            <DesktopApp
                config={config}
                isMobile={isMobile}
                variationId={this.props.variationId}
            />
        );
    }

    handleResize = () => {
        const onResize = () => {
            this.setState({
                isMobile: document.body.clientWidth < RESIZE_THRESHOLD,
            });
        };

        if (window.requestAnimationFrame) {
            requestAnimationFrame(onResize);
        } else {
            onResize();
        }
    };
}

export default App;



// WEBPACK FOOTER //
// ./src/components/App.js